const keyConstants = {
    BACKSPACE: 'Backspace',
    DEL: 'Delete',
    ESCAPE: 'Escape',
    TAB: 'Tab',
};


export default keyConstants;
